import React from "react";
import styles from "../../pricingList/PricingList.module.scss";
import { Table, TableBody } from "@material-ui/core";
import { TextValidator } from "react-material-ui-form-validator";
import Item from "../../../../../shared/item/Item";
import CheckBox from "../../../../../shared/checkBox/CheckBox";
import CheckCurrencyValue from "../../../../../utils/CheckCurrencyValue";
import {
  CheckBoxTableCell,
  NonEditTableCell,
  SpecsTableCell,
  WarningTableCell,
} from "../../../../../shared/pricing/dealerFees/TableComponents";

const DealerFeesRow = (props) => {
  function rowCheck(editedListed) {
    let checkedMark = false;
    for (const value of editedListed) {
      if (value === props.item.specs) {
        checkedMark = true;
      }
    }
    return checkedMark;
  }

  return (
    <div
      className={`${
        props.item.released || props.viewOnlyPricing
          ? styles.rowBorderHighlight
          : styles.rowBorderHighlightPriceChange
      } ${
        props.item.released &&
        props.editChecked &&
        rowCheck(props.rowEditedCheckbox)
          ? styles.rowBorderHighlightPriceEdited
          : styles.rowBorderHighlight
      } ${styles.dealerFeesRow}`}
    >
      <Table>
        <TableBody>
          <WarningTableCell>
            {!props.item.released && !props.viewOnlyPricing ? (
              <div
                className={styles.warning}
                data-testid={"warning" + props.index}
              />
            ) : (
              <div>
                {props.newlyReleased ? (
                  <div
                    className={styles.success}
                    data-testid={"success" + props.index}
                  />
                ) : props.rowEditSaved && rowCheck(props.rowEditedCheckbox) ? (
                  <div
                    className={styles.success}
                    data-testid={"success" + props.index}
                  />
                ) : (
                  ""
                )}
              </div>
            )}
          </WarningTableCell>

          <CheckBoxTableCell className={styles.rowItem}>
            <CheckBox
              checked={
                (!props.item.released && !props.viewOnlyPricing) ||
                (props.editChecked && rowCheck(props.rowEditedCheckbox))
              }
              isDisabled={props.isDisabled}
            />
          </CheckBoxTableCell>

          <SpecsTableCell className={styles.rowItem}>
            <Item value={props.item.specs} datatestid={"specs" + props.index} />
          </SpecsTableCell>
          <NonEditTableCell className={`${styles.rowItemBold} ${styles.right}`}>
            <Item value={props.item.year} />
          </NonEditTableCell>
          {props.fees &&
            props.fees.map((fee) => {
              return fee.isEditable ? (
                <NonEditTableCell>
                  {props.editEnabled[fee.key] ? (
                    <span className={styles.textBox}>
                      <TextValidator
                        name={fee.key + props.index}
                        value={props.item[fee.key]}
                        onChange={(e) =>
                          props.handleEdit(e, props.index, fee.key)
                        }
                        validators={[
                          "required",
                          "isPositiveNumberWithBigDecimal",
                        ]}
                        errorMessages={[
                          props.t("Error.requiredField"),
                          props.t("Error.invalidInput"),
                        ]}
                      />
                    </span>
                  ) : (
                    <div className={styles.alignRight}>
                      <Item
                        value={CheckCurrencyValue(
                          props.currencySymbol,
                          props.item[fee.key],
                          true
                        )}
                      />
                    </div>
                  )}
                </NonEditTableCell>
              ) : (
                <NonEditTableCell
                  className={`${styles.rowItemBold} ${styles.right}`}
                >
                  <Item
                    value={CheckCurrencyValue(
                      props.currencySymbol,
                      props.item[fee.key],
                      true
                    )}
                  />
                </NonEditTableCell>
              );
            })}
        </TableBody>
      </Table>
    </div>
  );
};

export default DealerFeesRow;
